// Translations for settings

export const enSettingsTranslations = {
  settings: {
    title: 'Settings',
    language: 'Language',
    profile: 'Profile',
    appearance: 'Appearance',
    notifications: 'Notifications',
    security: 'Security',
    billing: 'Billing',
    account: 'Account',
  },
};

export const esSettingsTranslations = {
  settings: {
    title: 'Configuración',
    language: 'Idioma',
    profile: 'Perfil',
    appearance: 'Apariencia',
    notifications: 'Notificaciones',
    security: 'Seguridad',
    billing: 'Facturación',
    account: 'Cuenta',
  },
};